import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { map, Observable, of } from 'rxjs';

import { UploadButtonComponent } from '@blaze-shared/shared-ui';
import { convertBlobToDataUrlFileResult, dataUrlToBase64 } from '@blaze-shared/shared-util';

import { type FormParameterDataType } from '../api-builder.model';

@Component({
  selector: 'blaze-typed-value-input-field',
  imports: [FormsModule, MatButtonToggleModule, ReactiveFormsModule, UploadButtonComponent],
  templateUrl: './typed-value-input-field.component.html',
  styleUrls: ['./typed-value-input-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypedValueInputFieldComponent {
  @Input() dataType?: FormParameterDataType;
  @Input() fieldName = '';
  @Input({ required: true }) fieldCtrl!: FormControl;

  fileChanged(file: File | undefined, control: FormControl): void {
    const file$: Observable<ApiActionFileInput | undefined> = file
      ? getApiActionFileInput(file)
      : of(undefined);
    file$.subscribe((contents) => {
      control.setValue(contents);
    });
  }
}

function getApiActionFileInput(file: File): Observable<ApiActionFileInput> {
  return convertBlobToDataUrlFileResult(file, file.name).pipe(
    map(({ url, filename, mimetype }) => ({
      filename,
      mimetype,
      content: dataUrlToBase64(url),
    })),
  );
}

interface ApiActionFileInput {
  filename: string;
  mimetype: string;
  content: string;
}
